/* ==========================================================================
   Logout Button Component
   Reusable logout button with consistent styling
   ========================================================================== */

import { LogOut } from 'lucide-react'

export interface LogoutButtonProps {
  /** Callback when logout button is clicked */
  onClick: () => void
  /** Optional additional CSS classes */
  className?: string
}

/**
 * Reusable logout button component with icon.
 * Provides consistent styling and hover states across the application.
 *
 * @example
 * ```tsx
 * <LogoutButton onClick={handleLogout} />
 * ```
 */
export function LogoutButton({ onClick, className = '' }: LogoutButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`p-2 rounded-md text-charcoal hover:bg-gray-100 transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-lavender ${className}`}
      aria-label="Log out"
    >
      <LogOut className="h-5 w-5" aria-hidden="true" />
    </button>
  )
}

export default LogoutButton
